import { useLoading } from '@/providers/LoadingProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useCurrentPurchaseOrder } from '@/providers/PurchaseOrderProvider';
import { useUpdateAccountingManualMode } from '@/hooks/api/0721_update_accounting_manual_mode';
import { useEffect, useState } from 'react';
import { toastError } from '@/lib/toast';
import { ModalConfirm } from '@/components/element/modal/ModalConfirm';
import { Link } from 'react-router-dom';

export const ManualModeEditElement = () => {
  const { setShowLoading } = useLoading();
  const { _w_, _t_, me, meTeamMember } = useCurrentTeamMember();
  const { _po_, mePurchaseOrderMember } = useCurrentPurchaseOrder();
  const { mutate, data, isPending, error } = useUpdateAccountingManualMode();
  const [manualMode, setManualMode] = useState<boolean>(false);

  const onManualModeEditClick = () => {
    mutate({
      identifier: _w_!.identifier,
      team_id: _t_!.id,
      purchase_order_id: _po_!.id,
      accounting_manual_mode: true,
    });
  };

  useEffect(() => setShowLoading(isPending), [isPending]);

  useEffect(() => {
    if (_po_) setManualMode(_po_.accounting_manual_mode);
  }, [_po_]);

  useEffect(() => {
    if (data) {
      _po_!.accounting_manual_mode = data.accounting_manual_mode;
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      const msgs: string[] = (error as any).response.data.errors || [];
      if (msgs.length > 0) toastError(msgs[0]);
    }
  }, [error]);

  return (
    <>
      <hr className="horizontal dark my-3" />

      <ModalConfirm
        modalId={`manualModeConfirm`}
        okClicked={() => onManualModeEditClick()}
        message={'手動管理モードに切り替えます。\nこの操作は元に戻せません。\nよろしいですか？'}
      />

      <div className="col-12 col-md-9">
        <div className="form-group">
          <label>手動管理</label>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              id="role05"
              type="checkbox"
              checked={manualMode}
              disabled={_po_!.accounting_manual_mode}
              onChange={(e) => {
                if (!_po_!.accounting_manual_mode) {
                  setManualMode((_) => !manualMode);
                }
              }}
            />
            <label className="form-check-label" htmlFor="role05">
              手動管理モードに切り替えて編集する
            </label>
          </div>
          <div className="mb-3 text-xs">
            手動管理モードをONにすると、支払実績が支払タスクから反映されなくなりますが、管理会計表を直接編集できます。一度手動編集モードにすると、元のモードに戻すことはできません。
          </div>
        </div>
      </div>
      <div className="col-12 col-md-3">
        <div className="form-group">
          <label>&nbsp;</label>
          <Link
            to={''}
            className={`btn w-100 btn-icon bg-gradient-dark ${!manualMode && 'disabled'} ${
              _po_!.accounting_manual_mode && 'disabled'
            }`}
            data-bs-toggle="modal"
            data-bs-target={`#manualModeConfirm`}
          >
            <i className="fa fa-plus"></i>切替実施
          </Link>
        </div>
      </div>
    </>
  );
};
